module.exports = __webpack_public_path__ + "img/FONDOPANTGDL02.4619b944.png";